module.exports = __webpack_public_path__ + "static/media/head-side-medical.2575f7a1.svg";